var _excluded = ["desc", "focusable", "title", "iconName", "className"];

function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import * as React from 'react';
import { string, bool } from 'prop-types';
import classNames from 'classnames';
var svg = /*#__PURE__*/React.createElement("svg", {
  viewBox: "0 0 32 32"
}, /*#__PURE__*/React.createElement("path", {
  d: "M16 3A13 13 0 113 16 13 13 0 0116 3m0-1a14 14 0 1014 14A14 14 0 0016 2z"
}), /*#__PURE__*/React.createElement("path", {
  d: "M16 9a7 7 0 11-7 7 7 7 0 017-7zm-.773-1h1.546a.222.222 0 00.226-.217.227.227 0 00-.005-.054L16.4 5.307a.415.415 0 00-.802 0l-.593 2.422a.222.222 0 00.221.271zm-5.43 2.89l1.093-1.093a.222.222 0 00-.036-.348L8.723 8.156a.415.415 0 00-.566.566l1.293 2.132a.222.222 0 00.348.036zM8 16.773v-1.546a.222.222 0 00-.217-.226.227.227 0 00-.054.005l-2.422.593a.415.415 0 000 .802l2.422.593A.222.222 0 008 16.773zm2.89 5.43L9.797 21.11a.222.222 0 00-.348.036l-1.293 2.132a.415.415 0 00.566.566l2.132-1.293a.222.222 0 00.07-.306.226.226 0 00-.034-.042zM16.773 24h-1.546a.222.222 0 00-.226.217.227.227 0 00.005.054l.593 2.422a.415.415 0 00.802 0l.593-2.422a.222.222 0 00-.221-.271zm5.43-2.89l-1.093 1.093a.222.222 0 00.036.348l2.131 1.293a.415.415 0 00.567-.567l-1.293-2.132a.222.222 0 00-.306-.07.226.226 0 00-.042.035zM24 15.227v1.546a.222.222 0 00.217.226.227.227 0 00.054-.005l2.422-.593a.415.415 0 000-.802l-2.422-.593a.222.222 0 00-.271.221zm-2.89-5.43l1.093 1.093a.222.222 0 00.348-.036l1.293-2.131a.415.415 0 00-.567-.567l-2.132 1.293a.222.222 0 00-.07.306.226.226 0 00.035.042z"
}));

var Icon = function Icon(_ref) {
  var desc = _ref.desc,
      _ref$focusable = _ref.focusable,
      focusable = _ref$focusable === void 0 ? false : _ref$focusable,
      title = _ref.title,
      iconName = _ref.iconName,
      className = _ref.className,
      rest = _objectWithoutProperties(_ref, _excluded);

  return /*#__PURE__*/React.createElement("svg", _extends({
    focusable: String(focusable),
    className: classNames('rds-svg--sun-circle-icon', className)
  }, rest, svg.props), title && /*#__PURE__*/React.createElement("title", null, title), desc && /*#__PURE__*/React.createElement("desc", null, desc), svg.props.children);
};

Icon.propTypes = {
  desc: string,
  focusable: bool,
  title: string,
  iconName: string,
  className: string
};
Icon.displayName = 'SunCircleIcon';
export default Icon;